/**
 * Usage Configurations Registry
 * Central registry for all usage configurations
 */

import { usageBottleConfig }   from './usageBottleConfig';
import { usageCapConfig }      from './usageCapConfig';
import { usageLabelConfig }    from './usageLabelConfig';
import { usageSupplyConfig }   from './usageSupplyConfig';
import { usageChemicalConfig } from './usageChemicalConfig';
import { usageProductConfig } from './usageProductConfig';

const usageConfigs = {
  bottles:   usageBottleConfig,
  caps:      usageCapConfig,
  labels:    usageLabelConfig,
  supplies:  usageSupplyConfig,
  chemicals: usageChemicalConfig,
  products:  usageProductConfig
};

export const getUsageConfig = (inventoryType) => {
  const config = usageConfigs[inventoryType];
  if (!config) {
    throw new Error(`No usage configuration found for inventory type: ${inventoryType}`);
  }
  return config;
};

export const hasUsageConfig = (inventoryType) => {
  return !!usageConfigs[inventoryType];
};
